module.exports = __webpack_public_path__ + "img/9.7bcbedf5.png";